import { useMemo } from 'react';
export const useFieldLayout = _ref => {
  let {
    createFieldLayout,
    margin,
    field,
    lastRow
  } = _ref;
  const {
    row,
    column,
    width,
    height
  } = field.layout;
  const {
    vertical,
    horizontal
  } = margin;
  const FieldLayout = useMemo(() => createFieldLayout({
    layout: {
      row,
      column,
      width,
      height
    },
    margin: {
      vertical,
      horizontal
    },
    lastRow
  }), [createFieldLayout, row, column, width, height, vertical, horizontal, lastRow]);
  return FieldLayout;
};
//# sourceMappingURL=use-field-layout.js.map